import { SKIP } from "../../actions";
import {
  MARGE_DEPASSEMENT_TTC,
  MIN_COMPENSATION_QUANTITY,
  orderRemainingRecreditAmount,
  orderRemainingRecreditAmountRaw,
  orderRemainingRefundableAmount,
} from "./utils";

export const SUPPORT_USER_LOAD = 'SUPPORT_USER_LOAD';
export const SUPPORT_USER_LOAD_BY_ORDER = 'SUPPORT_USER_LOAD_BY_ORDER';
export const SUPPORT_USER_LOADED = 'SUPPORT_USER_LOADED';

export const SEARCH_USER_CHANGE = 'SEARCH_USER_CHANGE';
export const SEARCH_USER_FILTER = 'SEARCH_USER_FILTER';

export const SUPPORT_MODAL_SHOW_CREDIT = 'SUPPORT_MODAL_SHOW_CREDIT';
export const SUPPORT_MODAL_HIDE_CREDIT = 'SUPPORT_MODAL_HIDE_CREDIT';
export const SUPPORT_MODAL_VALIDATE_CREDIT = 'SUPPORT_MODAL_VALIDATE_CREDIT';
export const SUPPORT_MODAL_VALIDATE_CREDIT_BULK = 'SUPPORT_MODAL_VALIDATE_CREDIT_BULK';
export const SUPPORT_MODAL_VALIDATE_CHANGE_STATUS = 'SUPPORT_MODAL_VALIDATE_CHANGE_STATUS';
export const SUPPORT_MODAL_SHOW_MULTIPLE_CREDIT = 'SUPPORT_MODAL_SHOW_MULTIPLE_CREDIT';
export const SUPPORT_MODAL_HIDE_MULTIPLE_CREDIT = 'SUPPORT_MODAL_HIDE_MULTIPLE_CREDIT';

export const SUPPORT_MODAL_SHOW_REFUND = 'SUPPORT_MODAL_SHOW_REFUND';
export const SUPPORT_MODAL_HIDE_REFUND = 'SUPPORT_MODAL_HIDE_REFUND';
export const SUPPORT_MODAL_SHOW_MULTIPLE_REFUND = 'SUPPORT_MODAL_SHOW_MULTIPLE_REFUND';
export const SUPPORT_MODAL_HIDE_MULTIPLE_REFUND = 'SUPPORT_MODAL_HIDE_MULTIPLE_REFUND';

export const SUPPORT_RECREDIT_SHIPPING_FEE = 'SUPPORT_RECREDIT_SHIPPING_FEE';
export const SUPPORT_REFUND_SHIPPING_FEE = 'SUPPORT_REFUND_SHIPPING_FEE';

// Invoice item actions (for salads)
export const SUPPORT_MODAL_SHOW_CREDIT_INVOICE_ITEM = 'SUPPORT_MODAL_SHOW_CREDIT_INVOICE_ITEM';
export const SUPPORT_MODAL_HIDE_CREDIT_INVOICE_ITEM = 'SUPPORT_MODAL_HIDE_CREDIT_INVOICE_ITEM';
export const SUPPORT_MODAL_VALIDATE_CREDIT_INVOICE_ITEM = 'SUPPORT_MODAL_VALIDATE_CREDIT_INVOICE_ITEM';
export const SUPPORT_MODAL_SHOW_REFUND_INVOICE_ITEM = 'SUPPORT_MODAL_SHOW_REFUND_INVOICE_ITEM';
export const SUPPORT_MODAL_HIDE_REFUND_INVOICE_ITEM = 'SUPPORT_MODAL_HIDE_REFUND_INVOICE_ITEM';
export const SUPPORT_MODAL_VALIDATE_REFUND_INVOICE_ITEM = 'SUPPORT_MODAL_VALIDATE_REFUND_INVOICE_ITEM';

// Salad-level actions (batch refund/recredit)
export const SUPPORT_MODAL_SHOW_REFUND_SALAD = 'SUPPORT_MODAL_SHOW_REFUND_SALAD';
export const SUPPORT_MODAL_HIDE_REFUND_SALAD = 'SUPPORT_MODAL_HIDE_REFUND_SALAD';
export const SUPPORT_MODAL_VALIDATE_REFUND_SALAD = 'SUPPORT_MODAL_VALIDATE_REFUND_SALAD';
export const SUPPORT_MODAL_SHOW_CREDIT_SALAD = 'SUPPORT_MODAL_SHOW_CREDIT_SALAD';
export const SUPPORT_MODAL_HIDE_CREDIT_SALAD = 'SUPPORT_MODAL_HIDE_CREDIT_SALAD';
export const SUPPORT_MODAL_VALIDATE_CREDIT_SALAD = 'SUPPORT_MODAL_VALIDATE_CREDIT_SALAD';

export const SUPPORT_MODAL_SHOW_SLOT = 'SUPPORT_MODAL_SHOW_SLOT';
export const SUPPORT_SLOT_LOADED = 'SUPPORT_SLOT_LOADED';

export const SUPPORT_MODAL_SHOW = 'SUPPORT_MODAL_SHOW';
export const SUPPORT_MODAL_HIDE = 'SUPPORT_MODAL_HIDE';


export const SUPPORT_MODAL_SHOW_ORDER_REDELIVER = 'SUPPORT_MODAL_SHOW_ORDER_REDELIVER';
export const SUPPORT_MODAL_HIDE_ORDER_REDELIVER = 'SUPPORT_MODAL_HIDE_ORDER_REDELIVER';
export const SUPPORT_MODAL_SHOW_ORDER_REDELIVER_LOADED = 'SUPPORT_MODAL_SHOW_ORDER_REDELIVER_LOADED';
export const SUPPORT_MODAL_SUBMIT_ORDER_REDELIVER = 'SUPPORT_MODAL_SUBMIT_ORDER_REDELIVER';

export const SUPPORT_MODAL_SHOW_ORDER_REPREPARE_BEFORE = 'SUPPORT_MODAL_SHOW_ORDER_REPREPARE_BEFORE';
export const SUPPORT_MODAL_SHOW_ORDER_REPREPARE = 'SUPPORT_MODAL_SHOW_ORDER_REPREPARE';
export const SUPPORT_MODAL_HIDE_ORDER_REPREPARE = 'SUPPORT_MODAL_HIDE_ORDER_REPREPARE';
export const SUPPORT_MODAL_SHOW_ORDER_REPREPARE_AFTER = 'SUPPORT_MODAL_SHOW_ORDER_REPREPARE_AFTER';
export const SUPPORT_MODAL_HIDE_ORDER_REPREPARE_AFTER = 'SUPPORT_MODAL_HIDE_ORDER_REPREPARE_AFTER';
export const SUPPORT_MODAL_SHOW_ORDER_REPREPARE_AFTER_LOADED = 'SUPPORT_MODAL_SHOW_ORDER_REPREPARE_AFTER_LOADED';
export const SUPPORT_MODAL_SUBMIT_ORDER_REPREPARE = 'SUPPORT_MODAL_SUBMIT_ORDER_REPREPARE';
export const SUPPORT_MODAL_SUBMIT_ORDER_REPREPARE_LOADED = 'SUPPORT_MODAL_SUBMIT_ORDER_REPREPARE_LOADED';
export const SUPPORT_MODAL_SHOW_ORDER_CRATES = 'SUPPORT_MODAL_ORDER_CRATES';

export const SUPPORT_ORDER_UPDATE = 'SUPPORT_ORDER_UPDATE';
export const SUPPORT_ORDER_UPDATED = 'SUPPORT_ORDER_UPDATED';

export const SUPPORT_ORDER_GIFT_MESSAGE = 'SUPPORT_ORDER_GIFT_MESSAGE';
export const SUPPORT_ORDER_ADDRESS_UPDATE = 'SUPPORT_ORDER_ADDRESS_UPDATE';
export const SUPPORT_ORDER_PREPZONE_UPDATE = 'SUPPORT_ORDER_PREPZONE_UPDATE';
export const SUPPORT_ORDER_REFUND = 'SUPPORT_ORDER_REFUND';
export const SUPPORT_ORDER_CRATE_ADD = 'SUPPORT_ORDER_CRATE_ADD';
export const SUPPORT_ORDER_CRATE_DELETE = 'SUPPORT_ORDER_CRATE_DELETE';
export const SUPPORT_ORDER_CRATE_UPDATED = 'SUPPORT_ORDER_CRATE_UPDATED';
export const SUPPORT_ORDER_STAT_DRIVER_LOADED = 'SUPPORT_ORDER_STAT_DRIVER_LOADED';

export const SUPPORT_USER_UPDATE = 'SUPPORT_USER_UPDATE';
export const SUPPORT_USER_UPDATED = 'SUPPORT_USER_UPDATED';
export const SUPPORT_USER_ADDRESS_LOAD = 'SUPPORT_USER_ADDRESS_LOAD';
export const SUPPORT_USER_ADDRESS_LOADED = 'SUPPORT_USER_ADDRESS_LOADED';
export const SUPPORT_USER_ADDRESS_UPDATE = 'SUPPORT_USER_ADDRESS_UPDATE';
export const SUPPORT_USER_ADDRESS_UPDATED = 'SUPPORT_USER_ADDRESS_UPDATED';
export const SUPPORT_BILLING_ADDRESS_BULK_UPDATE = 'SUPPORT_BILLING_ADDRESS_BULK_UPDATE';
export const SUPPORT_BILLING_ADDRESS_BULK_UPDATED = 'SUPPORT_BILLING_ADDRESS_BULK_UPDATED';
export const bulkUpdateBillingAddress = (payload) => ({ type: SUPPORT_BILLING_ADDRESS_BULK_UPDATE, payload });
export const SUPPORT_USER_EDIT_INTERNAL_NOTE = 'SUPPORT_USER_EDIT_INTERNAL_NOTE';
export const SUPPORT_USER_INTERNAL_NOTE_UPDATED = 'SUPPORT_USER_INTERNAL_NOTE_UPDATED';

export const SUPPORT_INVOICE_DOWNLOAD = 'SUPPORT_INVOICE_DOWNLOAD';
export const SUPPORT_RECEIPT_DOWNLOAD = 'SUPPORT_RECEIPT_DOWNLOAD';
export const SUPPORT_INVOICES_DOWNLOAD_BY_YEAR = 'SUPPORT_INVOICES_DOWNLOAD_BY_YEAR';
export const SUPPORT_ORDER_EXTERNAL_UPDATED = 'SUPPORT_ORDER_EXTERNAL_UPDATED';
export const SUPPORT_ORDER_STATUS_UPDATE = 'SUPPORT_ORDER_STATUS_UPDATE';

export const SUPPORT_STRIPESYNC_LOAD = 'SUPPORT_STRIPESYNC_LOAD';
export const SUPPORT_STRIPESYNC_LOADED = 'SUPPORT_STRIPESYNC_LOADED';

export const SUPPORT_PAYGREENSYNC_LOAD = 'SUPPORT_PAYGREENSYNC_LOAD';
export const SUPPORT_PAYGREENSYNC_LOADED = 'SUPPORT_PAYGREENSYNC_LOADED';

export const SUPPORT_CREDITSYNC_LOAD = 'SUPPORT_CREDITSYNC_LOAD';
export const SUPPORT_CREDITSYNC_LOADED = 'SUPPORT_CREDITSYNC_LOADED';

export const SUPPORT_DEPOSIT_USER_HISTORY_LOAD = 'SUPPORT_DEPOSIT_USER_HISTORY_LOAD';
export const SUPPORT_DEPOSIT_USER_HISTORY_LOADED = 'SUPPORT_DEPOSIT_USER_HISTORY_LOADED';
export const SUPPORT_DEPOSIT_USER_CURRENT_LOADED = 'SUPPORT_DEPOSIT_USER_CURRENT_LOADED';
export const SUPPORT_DEPOSIT_USER_CURRENT_LOAD = 'SUPPORT_DEPOSIT_USER_CURRENT_LOAD';
export const SUPPORT_DEPOSIT_USER_CREATE_RECEIVED = 'SUPPORT_DEPOSIT_USER_CREATE_RECEIVED';
export const SUPPORT_DEPOSIT_RELOAD = 'SUPPORT_DEPOSIT_RELOAD';
export const SUPPORT_DRIVER_LIST_LOAD = 'SUPPORT_DRIVER_LIST_LOAD';
export const SUPPORT_DRIVER_LIST_LOADED = 'SUPPORT_DRIVER_LIST_LOADED';
export const SUPPORT_DRIVER_LIST_FAILED = 'SUPPORT_DRIVER_LIST_FAILED';

export const SUPPORT_ACTIVITIESLOGS_LOAD = 'SUPPORT_ACTIVITIESLOGS_LOAD';
export const SUPPORT_ACTIVITIESLOGS_LOADED = 'SUPPORT_ACTIVITIESLOGS_LOADED';

export const SUPPORT_DELETE_ACCOUNT = 'SUPPORT_DELETE_ACCOUNT';
export const SUPPORT_FIX_CENTERS = 'SUPPORT_FIX_CENTERS';
export const SUPPORT_DISCONNECT_EDENRED = 'SUPPORT_DISCONNECT_EDENRED';

export const SUPPORT_CANCEL_SUBSCRIPTION = 'SUPPORT_CANCEL_SUBSCRIPTION';
export const SUPPORT_SUBSCRIPTION_CANCELED = 'SUPPORT_SUBSCRIPTION_CANCELED';

export const SUPPORT_CANCEL_CREDIT = 'SUPPORT_CANCEL_CREDIT';
export const SUPPORT_CANCEL_PAYGREEN_TRANSACTION = 'SUPPORT_CANCEL_PAYGREEN_TRANSACTION';

export const SUPPORT_TROLLEY_LOCATIONS_LOAD = 'SUPPORT_TROLLEY_LOCATIONS_LOAD';
export const SUPPORT_TROLLEY_LOCATIONS_LOADED = 'SUPPORT_TROLLEY_LOCATIONS_LOADED';

export const SUPPORT_LOAD_MORE_ORDERS = 'SUPPORT_LOAD_MORE_ORDERS';
export const SUPPORT_MORE_ORDERS_LOADED = 'SUPPORT_MORE_ORDERS_LOADED';

export const loadUser = (user_id, email) => {
  return {
    type: SUPPORT_USER_LOAD,
    user_id: user_id,
    email: email
  };
};

export const loadOrder = (order_id) => {
  return {
    type: SUPPORT_USER_LOAD_BY_ORDER,
    order_id: order_id,
  };
};

export const loadUserAddresses = (user_id) => {
  return {
    type: SUPPORT_USER_ADDRESS_LOAD,
    user_id: user_id
  };
};

export const loadTrolleyLocations = () => {
  return {
    type: SUPPORT_TROLLEY_LOCATIONS_LOAD,
  };
};

export const loadMoreOrders = (user_id, offset) => {
  return {
    type: SUPPORT_LOAD_MORE_ORDERS,
    user_id: user_id,
    offset: offset,
  };
};

export const showPopinProductCredit = (op, user, order) => {

  let obj = getPriceAndLabelForSuperProductStatus(op);

  // Une unité déjà remboursée ne peut plus être recréditée.
  const maxQuantity = Math.max(
    0,
    op.quantity - op.quantity_recredit - op.quantity_refund,
  );
  // On autorise une fraction de produit (ex: 0.2) ; le plancher tombe à
  // MIN_COMPENSATION_QUANTITY mais reste borné par maxQuantity pour ne pas
  // dépasser le restant quand celui-ci est déjà inférieur au plancher.
  const minQuantity = Math.min(MIN_COMPENSATION_QUANTITY, maxQuantity);

  // Plafond dur basé sur ce qu'il reste réellement à recréditer sur la
  // commande (sans la marge des 20€, réservée au dédommagement global qui
  // saisit un montant libre).
  const capLeft = order ? orderRemainingRecreditAmount(order) : null;

  return {
    "type": SUPPORT_MODAL_SHOW_CREDIT,
    "label": op.product.selling_name,
    "alertWarning": obj.additionalWarning,
    "alertInfo": obj.additionalInfo,
    "defaultQuantity": maxQuantity,
    "maxQuantity": maxQuantity,
    "minQuantity": minQuantity,
    "pricePerUnitQuantity": obj.pricePerUnitQuantity,
    "order_product_id": op.id,
    "recreditQuantity": op.quantity_recredit,
    "refundQuantity": op.quantity_refund,
    "capLeft": capLeft,
    "hardCap": capLeft !== null,
    userId: user && user.id,
  };
};


export const showPopinOrderCredit = (order, user) => {

  let pricePerUnitQuantity = 1;

  // Le back-end accepte de dédommager jusqu'à 20€ de plus que ce qu'il
  // reste réellement à recréditer (MARGE_DEPASSEMENT_TTC), puis tronque
  // silencieusement au-delà. On reflète cette même limite côté UI.
  //
  // On utilise orderRemainingRecreditAmountRaw qui peut renvoyer un nombre
  // NÉGATIF (à la différence de orderRemainingRecreditAmount qui plafonne
  // à 0). Garder le négatif est important pour le cas "commande déjà
  // sur-dédommagée" :
  //   - commande normale, reste 10€ à recréditer → 10 + 20 = 30€ max
  //   - commande sur-dédommagée de 5€         → -5 + 20 = 15€ max
  //     (la marge de 20€ est déjà entamée de 5€)
  //   - commande sur-dédommagée de plus de 20€ → résultat négatif, le
  //     Math.max(0, …) ramène à 0. Dans ce cas le bouton qui ouvre cette
  //     modale est déjà désactivé en amont (cf. OrderActions).
  const maxQuantity = Math.max(
    0,
    orderRemainingRecreditAmountRaw(order) + MARGE_DEPASSEMENT_TTC,
  );

  return {
    "type": SUPPORT_MODAL_SHOW_CREDIT,
    "label": `Commande #${order.random_id} dédommagement en crédit`,
    "defaultQuantity": 0,
    "pricePerUnitQuantity": pricePerUnitQuantity,
    "order_id": order.id,
    "maxQuantity": maxQuantity,
    "minQuantity": user ? -user.credits : 0,
    "userId": user && user.id,
    "labelQuantity": "Montant à recréditer",
    "subtype": "credit_compensation",
    // capLeft (clampé à 0) sert au form pour l'alerte de dépassement
    // dans la marge des 20€ tolérés par le back.
    "capLeft": orderRemainingRecreditAmount(order),
  };
};


export const showPopinMultipleProductCreditOrRefund = (
  order,
  user,
  type,
) => {

  let orderProducts = order.products.reduce(
    (acc, item) => {
      let obj = getPriceAndLabelForSuperProductStatus(item);
      if (
        obj.pricePerUnitQuantity === null
        || obj.pricePerUnitQuantity === 0
      ) {
        return acc;
      }

      // On ne peut ni recréditer ni rembourser une unité déjà passée par
      // l'autre canal — d'où la double soustraction dans les deux cas.
      const maxQuantity = Math.max(
        0,
        item.quantity - item.quantity_recredit - item.quantity_refund,
      );

      // Fraction de produit autorisée (ex: 0.2) ; plancher à
      // MIN_COMPENSATION_QUANTITY borné par le restant.
      const minQuantity = Math.min(MIN_COMPENSATION_QUANTITY, maxQuantity);

      let data = {
        selling_name: item.product.selling_name,
        alertWarning: obj.additionalWarning,
        alertInfo: obj.additionalInfo,
        defaultQuantity: maxQuantity,
        maxQuantity: maxQuantity,
        minQuantity: minQuantity,
        pricePerUnitQuantity: obj.pricePerUnitQuantity,
        order_product_id: item.id,
        recreditQuantity: item.quantity_recredit,
        refundQuantity: item.quantity_refund,
      };
      acc.push(data);
      return acc;
    },
    []
  );

  let label = "Valeur inconnue";
  if (type === SUPPORT_MODAL_SHOW_MULTIPLE_CREDIT) {
    label = `Commande #${order.random_id} dédommagement en crédit`;
  }
  else if (type === SUPPORT_MODAL_SHOW_MULTIPLE_REFUND) {
    label = `Commande #${order.random_id} dédommagement en remboursement`;
  }

  // Cap global : ce qu'il reste effectivement à débloquer sur la commande.
  // Sans ce cap, le form propose un montant que le back-end va
  // silencieusement tronquer. Pas de marge des 20€ ici : elle est
  // réservée au dédommagement global qui saisit un montant libre.
  let maxTotalAmount = null;
  if (type === SUPPORT_MODAL_SHOW_MULTIPLE_REFUND) {
    maxTotalAmount = orderRemainingRefundableAmount(order);
  }
  else if (type === SUPPORT_MODAL_SHOW_MULTIPLE_CREDIT) {
    maxTotalAmount = orderRemainingRecreditAmount(order);
  }

  return {
    type: type,
    label: label,
    orderProducts: orderProducts,
    userId: user && user.id,
    orderId: order.id,
    maxTotalAmount: maxTotalAmount,
  };
};


export const showPopinRefundOrder = (order) => {

  return {
    "type": SUPPORT_MODAL_SHOW_REFUND,
    "label": `Remboursement de la commande #${order.random_id}`,
    "order": order,
    "labelQuantity": "Montant à rembourser",
  };
};

export const showPopinReprepareOrderBefore = (order) => {
  // This is needed for saga to load products stocks to allow to "hit" checkbox of available products
  return {
    "type": SUPPORT_MODAL_SHOW_ORDER_REPREPARE_BEFORE,
    "order": order
  };
};

export const showPopinReprepareOrder = (order, products_details) => {
  return {
    "type": SUPPORT_MODAL_SHOW_ORDER_REPREPARE,
    "label": `Commande #${order.random_id} repréparation`,
    "order": order,
    "product_details": products_details
  };
};

export const showPopinReDeliverOrder = (order) => {
  return showPopinReDeliverOrderWithAddress(order, order.shipping_address);
};

export const showPopinReDeliverOrderWithAddress = (order, address) => {
  return {
    "type": SUPPORT_MODAL_SHOW_ORDER_REDELIVER,
    "label": `Commande #${order.random_id} nouvelle livraison`,
    "order": order,
    "postalCode": address.postal_code,
    "address": address
  };
};

export const showPopinOrderCrates = (order, taskId = null, userType = null) => {
  return {
    "type": SUPPORT_MODAL_SHOW,
    "modalData": {
      "modalType": "crate",
      order,
      taskId,
      userType,
    },
  };
};

export const showPopinReprepareOrderAfter = (order) => {
  // orderId and postalCode are used in Saga to load slots
  return {
    "type": SUPPORT_MODAL_SHOW_ORDER_REPREPARE_AFTER,
    "order": order,
    "modalData": {
      "orderId": order.id,
      "postalCode": order.shipping_address.postal_code,
    }
  };
};

export const submitRedeliverOrder = (data) => {
  console.log('in action payload deliver');
  // Data is generated from reprepare final form and sent to saga
  return {
    "type": SUPPORT_MODAL_SUBMIT_ORDER_REDELIVER,
    "data": data
  };
}

export const submitReprepareOrderAfter = (data) => {
  // Data is generated from reprepare final form and sent to saga
  return {
    "type": SUPPORT_MODAL_SUBMIT_ORDER_REPREPARE,
    "data": data
  };
};

export const showPopinProductRefund = (op, order) => {

  let obj = getPriceAndLabelForSuperProductStatus(op);

  return {
    "type": SUPPORT_MODAL_SHOW,
    "modalData": {
      "modalType": "refund",
      "title": op.product.selling_name,
      "alertWarning": obj.additionalWarning,
      "alertInfo": obj.additionalInfo,
      "defaultQuantity": op.quantity,
      "pricePerUnitQuantity": obj.pricePerUnitQuantity,
      "orderProductId": op.id,
      "recreditQuantity": op.quantity_recredit,
      "refundQuantity": op.quantity_refund,
      // Plafond dur = ce qu'il reste vraiment remboursable sur la commande.
      "capLeft": order ? orderRemainingRefundableAmount(order) : null,
    }
  };
};

export const validateCredit = (quantity, subtype, notes, pricePerUnitQuantity, modal, callback) => {
  let value = quantity * pricePerUnitQuantity;

  return {
    "type": SUPPORT_MODAL_VALIDATE_CREDIT,
    "id": modal.order_product_id || modal.order_id,
    "field": modal.order_product_id ? 'order_product_id' : 'order_id',
    "quantity": quantity,
    "creditAmount": value,
    "subtype": subtype,
    "notes": notes,
    "refreshUserId": modal.userId,
    "callback": callback,
  };
};

export const validateCreditBulk = (notes, subtype, products, modal) => {
  return {
    "type": SUPPORT_MODAL_VALIDATE_CREDIT_BULK,
    "id": modal.orderId,
    "field": 'order_id',
    "notes": notes,
    "subtype": subtype,
    "products": products,
    "refreshUserId": modal.userId,
  };
};

export const validateRefund = (quantity, subtype, notes, modal) => {

  return {
    "type": SUPPORT_ORDER_REFUND,
    "id": modal.order.id,
    "field": 'order_id',
    "refundAmount": quantity,
    "subtype": subtype,
    "notes": notes
  };
};

export const orderProductRefund = (quantity, subtype, notes, pricePerUnitQuantity, orderProductId) => {
  let value = quantity * pricePerUnitQuantity;

  return {
    "type": SUPPORT_ORDER_REFUND,
    "id": orderProductId,
    "field": 'order_product_id',
    "quantity": quantity,
    "refundAmount": value,
    "subtype": subtype,
    "notes": notes
  };
};

export const showPopinSlot = (order) => {
  return {
    "type": SUPPORT_MODAL_SHOW_SLOT,
    "modalData": {
      "modalType": "slot",
      "orderId": order.id,
      "postalCode": order.shipping_address.postal_code,
      "max_shipping_time": order.max_shipping_time,
      "shipping_time": order.shipping_time,
    },
  };
};

export const updateOrder = (orderId, toUpdate) => {
  return {
    "type": SUPPORT_ORDER_UPDATE,
    "toUpdate": toUpdate,
    "orderId": orderId,
  };
};

export const refundOrder = (quantity, subtype, notes, pricePerUnitQuantity, orderProductId) => {
  let value = quantity * pricePerUnitQuantity;

  return {
    "type": SUPPORT_ORDER_REFUND,
    "id": orderProductId,
    "field": 'order_product_id',
    "creditAmount": value,
    "subtype": subtype,
    "notes": notes
  };
};

export const showPopinOrderAddressName = (address) => {
  return {
    "type": SUPPORT_MODAL_SHOW,
    "modalData": {
      "modalType": "delivery_name",
      "address": address,
      "title": "Changer le nom / prenom sur la commande"
    },
  };
};

export const showPopinOrderAddressPhone = (address) => {
  return {
    "type": SUPPORT_MODAL_SHOW,
    "modalData": {
      "modalType": "delivery_phone",
      "address": address,
      "title": "Changer le numéro de téléphone sur la commande"
    },
  };
};

export const showPopinOrderAddress = (address, title, user_id = 0, address_type = "order_address") => {
  return {
    "type": SUPPORT_MODAL_SHOW,
    "modalData": {
      "modalType": "address",
      "address": address,
      "title": title,
      "user_id": user_id,  // Used in sagas
      "address_type": address_type,  // Address = order_address | ProfileAddress = user_address
    },
  };
};
export const showPopinOrderStatDriver = (order) => {
  return {
    "type": SUPPORT_MODAL_SHOW,
    "modalData": {
      "modalType": "order_stat_driver",
      "order": order,
      "title": "Détail du coût de livraison",
    },
  };
};

export const showPopinOrderPrepZone = (order, prepZone, pz) => {
  return {
    "type": SUPPORT_MODAL_SHOW,
    "modalData": {
      "modalType": "OrderPrepZone",
      "order": order,
      "prepZone": prepZone,
      "pz": pz,
      "title": 'Préparation de la zone ' + pz.name
    },
  };
};

export const showPopinOrderPrepZoneMarkDone = (order, opz) => {
  return {
    "type": SUPPORT_MODAL_SHOW,
    "modalData": {
      "modalType": "OrderPrepZoneMarkDoneModal",
      "order": order,
      "opz": opz,
      "title": 'Préparation de la zone ' + opz.pseudozone.name
    },
  };
};


export const showPopinProductChangeStatus = (op) => {
  return {
    "type": SUPPORT_MODAL_SHOW,
    "modalData": {
      "modalType": "change_status",
      "title": op.product.selling_name,
      "orderProductId": op.id,
      "oldStatus": op.status
    }
  };
};

export const validateChangeStatus = (order_product_id, status_code) => {
  return {
    "type": SUPPORT_MODAL_VALIDATE_CHANGE_STATUS,
    "id": order_product_id,
    "status_code": status_code
  };
};

export const validateChangeDeliveryName = (address) => {
  return {
    "type": SUPPORT_ORDER_ADDRESS_UPDATE,
    "address": address
  };
};

export const validateChangeDeliveryPhone = (address) => {
  return {
    "type": SUPPORT_ORDER_ADDRESS_UPDATE,
    "address": address
  };
};

export const showPopinConfirm = (msg, dispatchDatas) => {
  return {
    "type": SUPPORT_MODAL_SHOW,
    "modalData": {
      "modalType": "popin_confirm",
      "msg": msg,
      "title": 'Veuillez confirmer votre action',
      "dispatchDatas": dispatchDatas,
    }
  };
};
export const validatePopinConfirm = (dispatchDatas) => {
  /*
   * Dispatch Datas peut être de cette forme (comme pour updateOrder)
   *   updateOrder(
   *     order.id,
   *     {
   *       'option_tranquility': !order.option_tranquility
   *     }
   *   )
   *
   * Voir exemple dans /apps/support/components/GiftMessageModal => validate
   */
  return dispatchDatas;
};

export const showPopinGiftMessage = (order) => {
  return {
    "type": SUPPORT_MODAL_SHOW,
    "modalData": {
      "modalType": "gift_message",
      "title": "Message de la carte cadeau",
      "order": order
    }
  };
};
export const updateOrderGiftMessage = (orderId, gift_message) => {
  return {
    "type": SUPPORT_ORDER_GIFT_MESSAGE,
    "orderId": orderId,
    "gift_message": gift_message,
  };
};

export const act_loadCreditSync = (user_id) => {
  return {
    type: SUPPORT_CREDITSYNC_LOAD,
    user_id: user_id,
  };
};

export const act_loadStripeSync = (user_id) => {
  return {
    type: SUPPORT_STRIPESYNC_LOAD,
    user_id: user_id,
  };
};

export const act_loadPaygreenSync = (user_id) => {
  return {
    type: SUPPORT_PAYGREENSYNC_LOAD,
    user_id: user_id,
  };
};

export const act_loadDepositUserHistory = (user_id, offset) => {
  return {
    type: SUPPORT_DEPOSIT_USER_HISTORY_LOAD,
    user_id: user_id,
    offset: offset
  };
};

export const act_loadDriverList = () => {
  return {
    type: SUPPORT_DRIVER_LIST_LOAD,
  };
};

export const driverDepositReceived = (values) => {
  return {
    "type": SUPPORT_DEPOSIT_USER_CREATE_RECEIVED,
    "driver_id": values.driver_id,
    "user_id": values.user_id,
    "quantity": values.quantity,
    "product_id": values.product_id
  };
};
export const act_loadDepositUserCurrent = (user_id) => {
  return {
    type: SUPPORT_DEPOSIT_USER_CURRENT_LOAD,
    user_id: user_id
  };
};

export const loadActivitiesLogs = (order_id) => {
  return {
    type: SUPPORT_ACTIVITIESLOGS_LOAD,
    order_id: order_id,
  };
};



export function getPriceAndLabelForSuperProductStatus(op) {
  const pack = op.product_pack || op.product.pack;
  let pricePerUnitQuantity = op.unit_price || op.product.pack_price;
  let additionalWarning = '';
  let additionalInfo = '';
  const { super_product_status_and_amount: superProductStatusAndAmount } = op.product

  if (superProductStatusAndAmount) {
    if (superProductStatusAndAmount.is_superproduct_bought 
      && !superProductStatusAndAmount.is_unit_bought
    ) {
      if (superProductStatusAndAmount.unit_price_superproduct_bought != null) {
        pricePerUnitQuantity = superProductStatusAndAmount.unit_price_superproduct_bought;
        additionalInfo =
          'Ce produit est issu du superproduit "'
          + superProductStatusAndAmount.superproduct_name
          + '", le montant de remboursement est bien celui payé par le client.';
      }
      else {
        additionalWarning =
          'Ce produit est issu du superproduit "'
          + superProductStatusAndAmount.superproduct_name
          + '", avec plusieurs sous-produits différents.'
          + ' Son prix n\'a pas pu être déterminé.';
      }
    }
    else if (superProductStatusAndAmount.is_superproduct_bought) {
      additionalWarning = 'Ce produit est peut-être issu d\'un superproduit.';
    }
  }
  pricePerUnitQuantity = pricePerUnitQuantity / pack;
  return { pricePerUnitQuantity, additionalWarning, additionalInfo };
}

export const supportTransitArea = function (order) {
  const r = prompt("Changer la zone de transit principale");
  if (!r) {
    return { type: SKIP };
  }
  return updateOrder(
    order.id, { transit_area: r }
  );
};


export const recreditShippingFeeAction = (order_id) => {
  return {
    "type": SUPPORT_RECREDIT_SHIPPING_FEE,
    "id": order_id,
    "field": "order_id",
    "notes": ""
  };
};


export const refundShippingFeeAction = (order_id) => {
  return {
    "type": SUPPORT_REFUND_SHIPPING_FEE,
    "id": order_id,
    "field": "order_id",
    "notes": ""
  };
};

export const validateChangeBags = (
  orderId, numberOfBags, numberOfBagsIso, opzPatchs
) => {

  return {
    type: SUPPORT_ORDER_UPDATE,
    orderId,
    toUpdate: {
      number_of_bags: numberOfBags,
      number_of_bags_isotherm: numberOfBagsIso,
    },
    opzPatchs,
  };
};

// Invoice item action creators (for salads refund/recredit)
export const showPopinCreditInvoiceItem = (invoiceItem, order) => {
  const quantityRemaining = invoiceItem.quantity_bought - (invoiceItem.quantity_refunded || 0);
  
  return {
    type: SUPPORT_MODAL_SHOW_CREDIT_INVOICE_ITEM,
    label: invoiceItem.selling_name,
    maxQuantity: quantityRemaining,
    // Fraction autorisée (ex: 0.2) ; plancher borné par le restant.
    minQuantity: Math.min(MIN_COMPENSATION_QUANTITY, quantityRemaining),
    modalType: "credit_invoice_item",
    invoiceItemId: invoiceItem.invoice_item_id,
    orderId: order.id,
    totalPrice: invoiceItem.total_price,
    quantityBought: invoiceItem.quantity_bought,
    quantityRefunded: invoiceItem.quantity_refunded || 0,
  };
};

export const hidePopinCreditInvoiceItem = () => {
  return {
    type: SUPPORT_MODAL_HIDE_CREDIT_INVOICE_ITEM,
  };
};

export const validateCreditInvoiceItem = (quantity, subtype, notes, modal) => {
  return {
    type: SUPPORT_MODAL_VALIDATE_CREDIT_INVOICE_ITEM,
    invoiceItemId: modal.invoiceItemId,
    orderId: modal.orderId,
    quantity: quantity,
    subtype: subtype,
    notes: notes,
  };
};

export const showPopinRefundInvoiceItem = (invoiceItem, order) => {
  const quantityRemaining = invoiceItem.quantity_bought - (invoiceItem.quantity_refunded || 0);
  
  return {
    type: SUPPORT_MODAL_SHOW_REFUND_INVOICE_ITEM,
    label: invoiceItem.selling_name,
    maxQuantity: quantityRemaining,
    // Fraction autorisée (ex: 0.2) ; plancher borné par le restant.
    minQuantity: Math.min(MIN_COMPENSATION_QUANTITY, quantityRemaining),
    modalType: "refund_invoice_item",
    invoiceItemId: invoiceItem.invoice_item_id,
    orderId: order.id,
    totalPrice: invoiceItem.total_price,
    quantityBought: invoiceItem.quantity_bought,
    quantityRefunded: invoiceItem.quantity_refunded || 0,
  };
};

export const hidePopinRefundInvoiceItem = () => {
  return {
    type: SUPPORT_MODAL_HIDE_REFUND_INVOICE_ITEM,
  };
};

export const validateRefundInvoiceItem = (quantity, notes, modal) => {
  return {
    type: SUPPORT_MODAL_VALIDATE_REFUND_INVOICE_ITEM,
    invoiceItemId: modal.invoiceItemId,
    orderId: modal.orderId,
    quantity: quantity,
    notes: notes,
  };
};

// Salad-level action creators
export const showPopinRefundSalad = function(salad, order) {
  // Collecter tous les invoice items
  const allInvoiceItems = [salad.base_invoice_item];
  if (salad.extra_invoice_items && salad.extra_invoice_items.length > 0) {
    salad.extra_invoice_items.forEach(function(item) {
      allInvoiceItems.push(item);
    });
  }
  
  // Calculer quantityRemaining pour chaque item
  const quantitiesRemaining = allInvoiceItems.map(function(ii) {
    const refunded = ii.quantity_refunded || 0;
    return ii.quantity_bought - refunded;
  });
  const quantityRemaining = Math.min.apply(Math, quantitiesRemaining);
  
  // Construire le label
  const extraCount = salad.extra_invoice_items ? salad.extra_invoice_items.length : 0;
  const label = salad.base_product_selling_name + ' complète (base + ' + extraCount + ' extras)';
  
  // Extraire les données des invoice items
  const invoiceItems = allInvoiceItems.map(function(ii) {
    return {
      invoice_item_id: ii.invoice_item_id,
      selling_name: ii.selling_name,
      total_price: ii.total_price,
    };
  });
  
  return {
    type: SUPPORT_MODAL_SHOW_REFUND_SALAD,
    label: label,
    maxQuantity: quantityRemaining,
    // Fraction autorisée (ex: 0.2) ; plancher borné par le restant.
    minQuantity: Math.min(MIN_COMPENSATION_QUANTITY, quantityRemaining),
    invoiceItems: invoiceItems,
    orderId: order.id,
    totalPrice: salad.total_price,
    quantityBought: salad.total_quantity,
  };
};

export const hidePopinRefundSalad = function() {
  return {
    type: SUPPORT_MODAL_HIDE_REFUND_SALAD,
  };
};

export const validateRefundSalad = function(quantity, notes, modal) {
  return {
    type: SUPPORT_MODAL_VALIDATE_REFUND_SALAD,
    invoiceItems: modal.invoiceItems,
    orderId: modal.orderId,
    quantity: quantity,
    notes: notes,
  };
};

export const showPopinCreditSalad = function(salad, order) {
  // Collecter tous les invoice items
  const allInvoiceItems = [salad.base_invoice_item];
  if (salad.extra_invoice_items && salad.extra_invoice_items.length > 0) {
    salad.extra_invoice_items.forEach(function(item) {
      allInvoiceItems.push(item);
    });
  }
  
  // Calculer quantityRemaining pour chaque item
  const quantitiesRemaining = allInvoiceItems.map(function(ii) {
    const refunded = ii.quantity_refunded || 0;
    return ii.quantity_bought - refunded;
  });
  const quantityRemaining = Math.min.apply(Math, quantitiesRemaining);
  
  // Construire le label
  const extraCount = salad.extra_invoice_items ? salad.extra_invoice_items.length : 0;
  const label = salad.base_product_selling_name + ' complète (base + ' + extraCount + ' extras)';
  
  // Extraire les données des invoice items
  const invoiceItems = allInvoiceItems.map(function(ii) {
    return {
      invoice_item_id: ii.invoice_item_id,
      selling_name: ii.selling_name,
      total_price: ii.total_price,
    };
  });
  
  return {
    type: SUPPORT_MODAL_SHOW_CREDIT_SALAD,
    label: label,
    maxQuantity: quantityRemaining,
    // Fraction autorisée (ex: 0.2) ; plancher borné par le restant.
    minQuantity: Math.min(MIN_COMPENSATION_QUANTITY, quantityRemaining),
    invoiceItems: invoiceItems,
    orderId: order.id,
    totalPrice: salad.total_price,
    quantityBought: salad.total_quantity,
  };
};

export const hidePopinCreditSalad = function() {
  return {
    type: SUPPORT_MODAL_HIDE_CREDIT_SALAD,
  };
};

export const validateCreditSalad = function(quantity, subtype, notes, modal) {
  return {
    type: SUPPORT_MODAL_VALIDATE_CREDIT_SALAD,
    invoiceItems: modal.invoiceItems,
    orderId: modal.orderId,
    quantity: quantity,
    subtype: subtype,
    notes: notes,
  };
};

export const SUPPORT_RESTART_SALAD_PREP = 'SUPPORT_RESTART_SALAD_PREP';
export const SUPPORT_RESTART_SALAD_PREP_FAILURE = 'SUPPORT_RESTART_SALAD_PREP_FAILURE';
export const SUPPORT_MODAL_SHOW_RESTART_SALAD_PREP = 'SUPPORT_MODAL_SHOW_RESTART_SALAD_PREP';
export const SUPPORT_MODAL_HIDE_RESTART_SALAD_PREP = 'SUPPORT_MODAL_HIDE_RESTART_SALAD_PREP';

export const restartSaladPrep = function(orderId, choicesetTaskId) {
  return {
    type: SUPPORT_RESTART_SALAD_PREP,
    orderId: orderId,
    choicesetTaskId: choicesetTaskId,
  };
};

export const restartSaladPrepFailure = function(error) {
  return {
    type: SUPPORT_RESTART_SALAD_PREP_FAILURE,
    error: error,
  };
};

export const showPopinRestartSaladPrep = function(salad, task, order) {
  return {
    type: SUPPORT_MODAL_SHOW_RESTART_SALAD_PREP,
    salad: salad,
    task: task,
    order: order,
  };
};

export const hidePopinRestartSaladPrep = function() {
  return {
    type: SUPPORT_MODAL_HIDE_RESTART_SALAD_PREP,
  };
};
